export * from './cookies.manager';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/cookies/index.ts